import React from 'react';
import { Box, List } from '@mui/material';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import THEME from '../../constants/theme';
import ROUTES from '../../config/routes';
import { useNavigation } from '../../context/NavigationContext';
import { glassEffect } from '../../styles';
import { getLogo } from '../../utils/navigationUtils';
import { navigationMenu } from '../../config/navigation';

import NavigationMenuItem from './NavigationMenuItem';

const NavigationMenu = ({ textColor = '#000000', width = 250 }) => {
  const { expandedMenu, handleMenuToggle, activeSection, navigateToSection } =
    useNavigation();
  const location = useLocation();

  const menuItems = navigationMenu.filter(item => item.title !== 'Portal');
  const isHomePage = location.pathname === '/';
  const activeColor = THEME.COLORS.PRIMARY_BLUE;

  const handleNavigate = path => {
    navigateToSection('hero', path);
  };

  const handleScroll = (id, path) => {
    navigateToSection(id, path);
  };

  const logoSrc = getLogo(textColor);

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        width: width,
        background: 'transparent',
        color: textColor,
        display: {
          xs: 'none',
          sm: 'none',
          md: 'none',
          lg: 'none',
          xl: 'block'
        },
        borderLeft: 'none',
        paddingTop: '15vh',
        marginRight: '2vh',
        zIndex: 10,
        overflowY: 'auto',
        overflowX: 'hidden'
      }}
    >
      <List sx={{ padding: 0 }}>
        {menuItems.map(item => (
          <React.Fragment key={item.title}>
            {item.title === 'Library' && <Box sx={{ margin: '10px 0' }} />}
            <NavigationMenuItem
              item={item}
              expandedMenu={expandedMenu}
              handleMenuToggle={handleMenuToggle}
              handleNavigate={handleNavigate}
              handleScroll={handleScroll}
              location={location}
              activeSection={activeSection}
              textColor={textColor}
              activeColor={activeColor}
            />
          </React.Fragment>
        ))}
      </List>

      <Box sx={{ margin: '20px 0' }} />

      <Box
        sx={{
          ...(isHomePage
            ? glassEffect({
                padding: '8px 16px',
                borderRadius: '6px'
              })
            : {
                padding: '4px 0',
                border: `1px solid ${THEME.COLORS.PRIMARY_BLUE}`,
                borderRadius: '4px'
              }),
          textAlign: 'center',
          fontSize: '0.8rem',
          fontWeight: THEME.TYPOGRAPHY.FONT_WEIGHT.REGULAR,
          marginLeft: '10%',
          marginRight: 'auto',
          width: '50%',
          maxWidth: `${width * 0.7}px`,
          color: isHomePage
            ? THEME.COLORS.NEUTRAL_WHITE
            : THEME.COLORS.PRIMARY_BLUE,
          transition: `all ${THEME.TRANSITIONS.MEDIUM} ease`,
          '&:hover': {
            backgroundColor: isHomePage
              ? 'rgba(255, 255, 255, 0.25)'
              : THEME.COLORS.PRIMARY_BLUE_LIGHT,
            cursor: 'pointer',
            ...(isHomePage && {
              backdropFilter: 'blur(15px)'
            })
          },
          fontFamily: THEME.TYPOGRAPHY.FONT_FAMILY.SECONDARY
        }}
        onClick={() => handleNavigate(ROUTES.AUTH)}
      >
        Portal
      </Box>

      <Box sx={{ margin: '20px 0' }} />

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <img
          src={logoSrc}
          alt='MarQ Capital Logo'
          style={{
            width: '70%',
            maxWidth: `${width * 0.7}px`,
            height: 'auto',
            margin: '0 auto 0 0'
          }}
        />
      </Box>
    </Box>
  );
};

NavigationMenu.propTypes = {
  textColor: PropTypes.string,
  width: PropTypes.number
};

export default NavigationMenu;
